import _ from 'lodash';
import { type HeaderService, DeployEnv, Site, SLD } from '@patsnap-utils/biz';
import '@patsnap-ui/icon/assets/Privacy.svg';
import '@patsnap-ui/icon/assets/solid/AssigneeAcademy.svg';
import '@patsnap-ui/icon/assets/solid/BookmarkBook.svg';
import '@patsnap-ui/icon/assets/solid/conversation.svg';
import '@patsnap-ui/icon/assets/solid/global.svg';
import '@patsnap-ui/icon/assets/solid/HelpCentre.svg';
import '@patsnap-ui/icon/assets/solid/users.svg';
import '@patsnap-ui/icon/assets/Term.svg';
import { getSiteRegion, SiteRegion } from '../site-region';

const messages: Record<string, unknown> = {
    cn: {
        help: {
            course: '产品教程',
            helpCenter: '帮助中心',
            dataCoverage: '数据范围',
            askForHelp: '需要帮助',
            courseLearning: '课程学习',
            patsnapCommunity: '交流社区',
            terms: '服务条款',
            policy: '隐私政策',
        },
    },
    en: {
        help: {
            course: 'Product Tutorial',
            helpCenter: 'Help Center',
            dataCoverage: 'Data Coverage',
            askForHelp: 'Ask for help',
            courseLearning: 'Course Learning',
            patsnapCommunity: 'Patsnap Community',
            terms: 'Terms of Service',
            policy: 'Privacy Policy',
        },
    },
    jp: {
        help: {
            course: '製品チュートリアル',
            helpCenter: 'ヘルプ',
            dataCoverage: 'データ範囲',
            askForHelp: 'お問合せ',
            courseLearning: 'コースの勉強',
            patsnapCommunity: 'オンラインコミュニティ',
            terms: '利用規約',
            policy: 'プライバシーポリシー',
        },
    },
    tw: {
        help: {
            course: '產品教程',
            helpCenter: '幫助中心',
            dataCoverage: '資料範圍',
            askForHelp: '需要幫助',
            courseLearning: '課程學習',
            patsnapCommunity: '交流社區',
            terms: '服務條款',
            policy: '隱私政策',
        },
    },
};

const EU_HELP_LINK = 'https://patsnap.zendesk.com/auth/v2/login/continue_with_sso_tracking?auth_origin=4665402834717%2Cfalse%2Ctrue&brand_id=4665402834717&locale=en-us&remote_auth_id=18719448547741&return_to=https%3A%2F%2Fpatsnap.zendesk.com%2Fhc%2Fen-us&role=end_user&theme=hc';
const HELP_CENTER_WIDGET_KEY = 'eureka-help-center';

const generateHelpLink = (region: DeployEnv) => {
    return new Site({ sld: SLD.EUREKA, pathname: 'ip/drafting-help-web' }).href;
};

const getHelpCenter = (i18n: any, headerService: HeaderService) => {
    const region = getSiteRegion();
    const isCn = region === SiteRegion.CN;
    const helpLink = generateHelpLink(_.toLower(region) as DeployEnv);
    const dataCoverageLink = isCn ? 'https://analytics.zhihuiya.com/status' : 'https://help.patsnap.com/hc/en-us/articles/27867020371869-Eureka-data-types-of-overviews';
    const termLink = isCn ? 'https://www.zhihuiya.com/legal/terms' : 'https://www.patsnap.com/legal/';
    const privacyLink = isCn ? 'https://www.zhihuiya.com/legal/privacy' : 'https://www.patsnap.com/legal/privacy-policy/';
    const courseLearningLink = 'https://x.zhihuiya.com/#/section/specialInfo/1584822268569501697';
    const courseLink = 'https://space.bilibili.com/2063121445?spm_id_from=333.337.0.0';

    Object.keys(messages).forEach(locale => {
        i18n.mergeLocaleMessage(locale, messages[locale]);
    });

    let helpItems: ({ icon: string; label: any; href: any; } | null)[] = [
        { icon: 'SolidHelpCentre', label: i18n.t('help.helpCenter'), href: helpLink },
    ];

    if (isCn) {
        helpItems = _.concat([
            { icon: 'SolidAssigneeAcademy', href: courseLink, label: i18n.t('help.course') },
        ], helpItems, [
            { icon: 'SolidBookmarkBook', href: courseLearningLink, label: i18n.t('help.courseLearning') },
        ]);
    } else {
        helpItems = _.concat(helpItems, [
            { icon: 'SolidGlobal', label: i18n.t('help.dataCoverage'), href: dataCoverageLink },
            { icon: 'SolidConversation', label: i18n.t('help.askForHelp'), href: new Site({ sld: SLD.HELP, pathname: 'hc/en-us/requests/new' }).href },
        ]);
    }

    helpItems = _.concat(helpItems, [
        null,
        { icon: 'Term', label: i18n.t('help.terms'), href: termLink },
        { icon: 'Privacy', label: i18n.t('help.policy'), href: privacyLink },
    ]);

    const helpCenterWidget = {
        key: HELP_CENTER_WIDGET_KEY,
        icon: 'HelpCenter',
        trigger: 'hover',
        menu: helpItems,
    };

    if (!headerService.right) headerService.right = [];

    const existingIndex = headerService.right.findIndex((widget) => {
        return typeof widget !== 'string'
            && (widget.key === HELP_CENTER_WIDGET_KEY || widget.icon === 'HelpCenter');
    });

    if (existingIndex === -1) {
        headerService.right = headerService.right.concat(helpCenterWidget);
        return;
    }

    headerService.right = headerService.right.map((widget, index) => {
        return index === existingIndex ? helpCenterWidget : widget;
    });
};

export {
    getHelpCenter,
};
